// @flow

import React from 'react';
import { SelectProps } from 'antd/lib/select';

import type { MaintenanceWorkType } from './../../lib/types';
import { maintenanceWorkTypeApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';

export default (selectProps: SelectProps) => (
  <AutocompleteSelect
    placeholder="Выберите вид работ"
    fetch={maintenanceWorkTypeApi.fetchMaintenanceTypeWork}
    fetchSingle={maintenanceWorkTypeApi.getMaintenanceTypeWork}
    notFoundText="Виды работ не найдены"
    renderOption={(maintenanceWorkType: MaintenanceWorkType, Option) => (
      <Option key={maintenanceWorkType.id} value={maintenanceWorkType.id}>
        {maintenanceWorkType.name}
      </Option>
    )}
    {...selectProps}
  />
);
